import { AiAgentAppointmentTypesComponent } from 'app/components/ai-agent-appointment-types/AiAgentAppointmentTypesComponent'
import { useAiAgentAppointmentTypes } from 'app/components/ai-agent-appointment-types/useAiAgentAppointmentTypes'

export default function AppointmentTypes() {
  const hookData = useAiAgentAppointmentTypes()
  return <AiAgentAppointmentTypesComponent {...hookData} />
}
